export default {"src":"/_next/static/media/MCHP.ebb4383a.svg","height":18,"width":18};